import React from "react"
import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import styles from "./Index.module.css"
import { BreadCrumbs } from "ui/BreadCrumbs"
import classNames from "classnames"

export const ClientMessagesLayout = () => {
  return (
    <Layout className={styles.layout}>
      <BreadCrumbs className={classNames("pl-m pr-m")} iconName={"messages"} category={"Messages"} subPages={[]} />
      <Outlet />
    </Layout>
  )
}
